/*************************************************/
/* CUSTOM FILEUPLOAD FOR FORMS                                        */
/*************************************************/
export function customupload(body) {
    const fieldselector = '.customuploadfield input[type=file]';
    const customuploadbuttonselector = '.customuploadfield .file-select-button'; 
    //TODO: Make sure there can be multiple fields by getting each ID and make sure to select the proper buttons etc for events!
    
    const fieldElements = document.querySelectorAll(fieldselector); 
    const uploadButton = document.querySelectorAll(customuploadbuttonselector)
    
    const init = () => {
      if (!fieldElements.length<0) {
        return; // Return early if there is no custom upload field
      }
  
      //TODO: set events on each fieldElement etc. 
      fieldElements.forEach(field => {
        //setup event: just forward the click to the hidden filepicker
        let btn =  field.nextElementSibling;
        btn.addEventListener('click', ()=>{
            field.click();
        });
        //setup event: Listen for selected files to change the text of the span. 
        field.addEventListener('change', (e)=>{
            if(e.target.files.lenght===0){
                //This should come from outside the script since it is set by the formfield... maybe a property that we can read here? 
                field.nextElementSibling.textContent =btn.dataset.nofilestext;
                return;
            }
            if(e.target.files.length===1){
                btn.nextElementSibling.textContent = e.target.files[0].name;
            }
            else{
                btn.nextElementSibling.textContent =`${e.target.files.length}` + " " +btn.dataset.nooffiles;
            }

        });
      });
    };
  
    init();
  }
